import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AccordionComponent } from '@domgen/dgx-fe-components/accordion';
import { RichTextComponent } from '@domgen/dgx-fe-components/content';
import { PanelComponent } from '@domgen/dgx-fe-components/panel';

@Component({
  selector: 'checkout-direct-debit-guarantee-panel',
  templateUrl: './direct-debit-guarantee-panel.component.html',
  styleUrls: ['./direct-debit-guarantee-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [PanelComponent, NgIf, RichTextComponent, AccordionComponent],
})
export class DirectDebitGuaranteePanelComponent {
  @Input() title?: string;
  @Input() legalTerms?: string;
}
